/**
 * @see ../../../../../../../../vendor/apache-solr-for-typo3/solr/Resources/Public/JavaScript/suggest_controller.js
 */

import Autocomplete from '../vendor/autocomplete';

let searchMain, searchMeta, searchHero;

class SuggestController {
  constructor() {
    this.init = function() {
      Autocomplete.init();

      const opts = {
        autoselectFirst: false,
        fullWidth: true,
        maximumItems: 0,
        fixed: false,
        fillIn: false,
        ignoreEnter: false,
        //onSelectItem: console.log,
        queryParam: 'tx_solr[queryString]',
        liveServer: true,
        server: '/suche?type=7384',
        serverMethod: 'POST',
        noCache: true,
        suggestionsThreshold: 2,
        debounceTime: 50,
        onServerResponse: async (response) => {
          const data = await response.json();
          let suggestions = $.map(data.suggestions, function(count, suggestion) {
            return { label: suggestion, value: suggestion };
          });
          return suggestions;
        },
        onChange: (item) => {
          //console.log(item);
        },
        onSelectItem: (item, inst) => {
          console.log(item);
          inst._searchInput.form.submit();
        },
      };

      if (document.getElementById('hero-search-input') instanceof HTMLElement) {
        searchHero = new Autocomplete(document.getElementById('hero-search-input'), opts);
      }
      if (document.getElementById('main-search-input') instanceof HTMLElement) {
        searchMain = new Autocomplete(document.getElementById('main-search-input'), opts);
      }
      if (document.getElementById('metamenu-search-input') instanceof HTMLElement) {
        searchMeta = new Autocomplete(document.getElementById('metamenu-search-input'), opts);
      }
    };
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (
    document.getElementById('hero-search-input') instanceof HTMLElement ||
    document.getElementById('main-search-input') instanceof HTMLElement ||
    document.getElementById('metamenu-search-input') instanceof HTMLElement
  ) {
    /** solr search autocomplete **/
    var solrSuggestController = new SuggestController();
    solrSuggestController.init();
  }
});
